import React from "react";
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';

type DeadCatalogProps = {
  deadCatalog: any
}

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
  ...theme.applyStyles('dark', {
    backgroundColor: '#1A2027',
  }),
}));

export const DeadCatalogDetailTab: React.FC<DeadCatalogProps> = ({ deadCatalog }) => {

  return (

    <Stack spacing={2} >
      <Item style={{ marginBottom: '10px', backgroundColor: 'rgba(245, 239, 239, 0.87)' }}>

        <div style={{ marginTop: '30px', marginLeft:'20px', display: 'flex', justifyContent: 'space-between' }}>
          <div style={{ marginBottom: '1rem', fontWeight: 700, fontSize: '25px', width: '48%', textAlign: 'left', color:'black' }}>{deadCatalog?.catalogName}</div>

        </div>
        <div style={{ marginLeft:'20px', minHeight:'60vh', justifyContent: 'space-between' }}>
            <div style={{ marginLeft:'10px', marginBottom: '1rem', fontSize: '16px', width: '100%', textAlign: 'left', color:'black' }}><span style={{fontWeight:700}}> 1 HR FUEL MOISTURE STICK RADIUS: </span> {deadCatalog?.stickRadius1HrFuelMoisture}</div>
            <div style={{ marginLeft:'10px', marginBottom: '1rem', fontSize: '16px', width: '100%', textAlign: 'left', color:'black' }}><span style={{fontWeight:700}}> 10 HR FUEL MOISTURE STICK RADIUS:</span> {deadCatalog?.stickRadius10HrFuelMoisture}</div>
            <div style={{ marginLeft:'10px', marginBottom: '1rem', fontSize: '16px', width: '100%', textAlign: 'left', color:'black' }}><span style={{fontWeight:700}}> 100 HR FUEL MOISTURE STICK RADIUS:</span> {deadCatalog?.stickRadius100HrFuelMoisture}</div>
            <div style={{ marginLeft:'10px', marginBottom: '2rem', fontSize: '16px', width: '100%', textAlign: 'left', color:'black' }}><span style={{fontWeight:700}}> 1000 HR FUEL MOISTURE STICK RADIUS:</span> {deadCatalog?.stickRadius1000HrFuelMoisture}</div>
        </div>
      </Item>

    </Stack>
  );
}